import { render, staticRenderFns } from "./EmailPDPA.vue?vue&type=template&id=660fc150"
import script from "./EmailPDPA.vue?vue&type=script&lang=js"
export * from "./EmailPDPA.vue?vue&type=script&lang=js"
import style0 from "./EmailPDPA.vue?vue&type=style&index=0&id=660fc150&prod&class=scoped&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports